module.exports = __webpack_public_path__ + "static/media/Pin_flat-tire-icon.6307f000.svg";